(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('QuestionController', QuestionController);

    QuestionController.$inject = ['$scope', '$state', 'Question', 'QuestionSearch'];

    function QuestionController ($scope, $state, Question, QuestionSearch) {
        var vm = this;
        vm.questions = [];
        vm.loadAll = function() {
            Question.query(function(result) {
                vm.questions = result;
            });
        };

        vm.search = function () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            QuestionSearch.query({query: vm.searchQuery}, function(result) {
                vm.questions = result;
            });
        };
        vm.loadAll();
        
    }
})();
